<template>
  <section class="file-wrapper">
    <div class="mid-content">
      <div class="breadcumb" v-if="!$store.state.SearchValue">
        <ul>
          <li
            :class="
              `/file/${fileID}` === item.value ? '' : 'text-link'
            "
            v-for="(item, index) in $store.state.nameNavigation"
            :key="index"
            @click="handleNavigationBarRedirect(item, index)"
          >
            {{ `${item.name}` }}
          </li>
        </ul>
      </div>
      <div class="top-heading">
        <h2>{{ getUserFile.CurrentFolderName }}</h2>
        <span>
          {{ getFileListDataLength }} {{$t('Files')}},
          {{ getFolderListDataLength }} {{$t('Folders')}} </span
        >
      </div>
      <!-- <div
        class="no-data"
        v-if="!(getUserFileData.length) && !(getUserFolderData.length)"
      >
        <img src="../assets/images/ic_blank_data.svg" alt />
        <span>{{$t('No Data Found')}}</span>
      </div> -->
      <div class="close-option"></div>
      <folder />
      <loader91 v-if="isLoading"></loader91>
    </div>
  </section>
</template>
<script>
import folder from '../components/folder';
import { mapGetters } from 'vuex';
import '../js/loading-bar.js';
import { SessionHelper, LANG } from "../utils/session";
export default {
  name: 'File',
  components: {
    folder,
  },
  data() {
    return {
      folder: this.$route.params.name,
      isLoading: true,
      currentFolderId: null,
      fileID: null
    };
  },
  computed: {
    ...mapGetters(['getUserFile', 'getFolderId',   "getUserFileData",
      "getUserFolderData","getFileListDataLength", "getFolderListDataLength"]),
  },
  watch: {
    '$route.params.name'(to, from) {
      this.userFile();
    },
    fileID: function(newVal, oldVal){
      console.log('=newVal=',newVal)
      this.$store.state.nameNavigation.filter((item, index) => {
          if (item.value === `/file/${newVal}`) {
            console.log('==active Tab=', index, this.$store.state.nameNavigation.length)
            this.$store.state.nameNavigation.splice(index+1,this.$store.state.nameNavigation.length)
          }
      });
    }
  },
  
  mounted() {
    this.isLoading = false;
    this.userFile();
    if (this.$route.params.name === undefined) {
      this.$store.commit('setCurrentFolderId', this.getUserFile.root);
    }
  },

  methods: {
    handleNavigationBarRedirect(item, index) {
      if (!(`/file/${this.fileID}` === item.value)) {
        this.$store.state.nameNavigation.splice(
          index + 1,
          this.$store.state.nameNavigation.length
        );
        var id = -(this.$store.state.nameNavigation.length - index);
        this.$router.push(item.value);
      }
    },
    async userFile() {
      this.isLoading = true;
      let file_id_string = this.$route.params.name.split('/');
      let file_id = file_id_string[file_id_string.length - 1];
      this.fileID = file_id 

      await this.$store
        .dispatch('userFile', {
          headers: {
            'folder-id': file_id,
            limit: 0,
          },
        })
         .then((response) => {
          this.$store.commit('setUserFile', response);
          this.$store.commit('setUserFolderData', response.folder);
          this.$store.commit('setUserFileData', response.Data);
          this.$store.commit('setCurrentFolderId', file_id);
          var bool = false;
          this.$store.state.nameNavigation.filter((item, index) => {
            if (item.value === `/file/${file_id}`) {
              return (bool = true);
            }
            return bool;
          });
          if (!bool) {
            this.$store.commit('NameNavigationRoute', {
              name: this.getUserFile.CurrentFolderName,
              value: `/file/${file_id}`,
            });
          }
           var els = document.querySelectorAll('.select-img');
          for (var i = 0; i < els.length; i++) {
            els[i].classList.remove('select-img');
          }
          this.isLoading = false;
        })
        .catch((err)=>{
        this.isLoading = false;
        if((err.response.data.message === 'Token is expired!') || (err.response.data.message === 'Invalid token.')){
          SessionHelper.refereshJwtToken();
          if (SessionHelper.getCookie('JWT-TOKEN') !== 'null') {
            this.userFile()
          }
        }
      })
    },
  },
};
</script>
